export type DeviceType = 'desktop' | 'mobile';
export const DESKTOP = 'desktop';
export const MOBILE = 'mobile';
